import { render, staticRenderFns } from "./order-appart-add-or-update.vue?vue&type=template&id=1a0fa15c&scoped=true"
import script from "./order-appart-add-or-update.vue?vue&type=script&lang=js"
export * from "./order-appart-add-or-update.vue?vue&type=script&lang=js"
import style0 from "./order-appart-add-or-update.vue?vue&type=style&index=0&id=1a0fa15c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a0fa15c",
  null
  
)

export default component.exports